var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card',{attrs:{"title":"轨迹查询"}},[_c('MapTrack',{ref:"trackMap"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }